import { render, staticRenderFns } from "./settlement-attachments.vue?vue&type=template&id=5e2f069d&scoped=true"
import script from "./settlement-attachments.vue?vue&type=script&lang=js"
export * from "./settlement-attachments.vue?vue&type=script&lang=js"
import style0 from "./settlement-attachments.vue?vue&type=style&index=0&id=5e2f069d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2f069d",
  null
  
)

export default component.exports